import React, { useEffect, useState, useRef  } from "react";
import { motion } from "framer-motion";

export default function MouMoa({ 
  accent = "#115e32",
  pageTitle = "MoU and MoA | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
	const slides = [
    {
      id: "unisza",
      title: "Universiti Sultan Zainal Abidin",
      subtitle: "Academic Partners",
      img: "/img/unisza.png",
      steps: [
        
      ]
    },
    {
      id: "evercare",
      title: "Evercare Hospital Chattogram",
      subtitle: "Strategic Partner",
      img: "/img/evercare.jpg",
      steps: [
        
      ]
    },
	{
      id: "parkview",
      title: "Parkview Hostpital Limited",
      subtitle: "Strategic Partner",
      img: "/img/parkview-logo.png",
      steps: [
        
        
      ]
    },
	{
      id: "national",
      title: "National Hostpital Chattogram Ltd.",
      subtitle: "Strategic Partner",
      img: "/img/national-hospital.jpg",
      steps: [
        
        
      ]
    },
	{
      id: "ibnsina",
      title: "IBN SINA Trust",
      subtitle: "Strategic Partner",
      img: "/img/ibn-sina.png",
      steps: [
        
        
      ]
    },
  ];
  const [index, setIndex] = useState(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    startAutoPlay();
    return () => stopAutoPlay();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index]);

  function startAutoPlay() {
    stopAutoPlay();
    timeoutRef.current = setTimeout(() => {
      setIndex((i) => (i + 1) % slides.length);
    }, 6000);
  }

  function stopAutoPlay() {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  }
  return (
    <div className="relative overflow-hidden">
      {/* ===== Hero Section ===== */}
      <section className="relative bg-gradient-to-b from-[#B7EAFC] via-[#F0FCFF] to-[#F0FCFF] py-20">
        {/* Decorative SVG */}
        <svg
          className="absolute top-0 left-0 w-full h-full opacity-10"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          viewBox="0 0 800 400"
        >
          <path
            d="M 0 200 Q 200 100 400 200 T 800 200 V 400 H 0 Z"
            fill="#b38a1f"
          />
          <circle cx="700" cy="100" r="80" fill="#1f6da8" opacity="0.4" />
          <circle cx="100" cy="350" r="50" fill="#b38a1f" opacity="0.4" />
        </svg>

        <div className="relative z-10 container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1f6da8] mb-4 animate-fadeInDown animate-bounce">
            MoU and MoA
          </h1>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto animate-fadeInUp">
            University of Creative Technology, Chittagong (UCTC) – A vision-driven
            institution for innovation, technology, and excellence in higher
            education.
          </p>
        </div>
      </section>
	  <section className="max-w-6xl mx-auto">
		 {/* Main animated carousel + details */}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden grid grid-cols-1 md:grid-cols-2">
          <div className="p-6 flex flex-col gap-4">
            <motion.div
              key={slides[index].id}
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -30 }}
              transition={{ duration: 0.6 }}
              className="flex-1"
            >
              <h2 className="text-xl font-bold mb-2">{slides[index].title}</h2>
              <p className="text-sm text-gray-600 mb-4">{slides[index].subtitle}</p>

              <ol className="space-y-3">
                {slides[index].steps.map((s, idx) => (
                  <motion.li
                    key={s}
                    initial={{ opacity: 0, y: 8 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 * idx }}
                    className="flex items-start gap-3"
                  >
                    <div className="w-8 h-8 rounded-full flex items-center justify-center bg-pink-50 text-pink-600 font-semibold">{idx + 1}</div>
                    <div>
                      <div className="font-medium">{s}</div>
                      <div className="text-xs text-gray-500">Follow the screenshots to the right for visual help.</div>
                    </div>
                  </motion.li>
                ))}
              </ol>

              <div className="mt-6 flex items-center gap-3">
                <button
                  onClick={() => setIndex((i) => (i - 1 + slides.length) % slides.length)}
                  className="px-4 py-2 rounded-md border hover:bg-gray-50"
                >
                  Prev
                </button>
                <button
                  onClick={() => setIndex((i) => (i + 1) % slides.length)}
                  className="px-4 py-2 rounded-md bg-pink-600 text-white hover:opacity-95"
                >
                  Next
                </button>

               
              </div>
            </motion.div>

            
          </div>

          <div className="p-4 bg-gradient-to-br from-gray-50 to-white flex flex-col items-center justify-center">
            <motion.img
              key={slides[index].img}
              src={slides[index].img}
              alt={slides[index].title}
              className="max-w-full max-h-[420px] object-contain rounded-lg shadow-sm"
              initial={{ scale: 0.98, opacity: 0.6 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.8 }}
            />

            
          </div>
        </div>
	   </section>
    </div>
  );
}
